const IMGPROXY_SUFFIX = '/img';

export const filesHostFromImgproxy = (imgproxyUrl: string): string => {
    const host = imgproxyUrl.endsWith('/') ? imgproxyUrl.slice(0, -1) : imgproxyUrl;

    if (host.endsWith(IMGPROXY_SUFFIX)) {
        return host.slice(0, -IMGPROXY_SUFFIX.length);
    }

    return host;
};

export const FILES_HOST = filesHostFromImgproxy(process.env.NEXT_PUBLIC_IMGPROXY_HOST ?? '');
